import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';

@Component({
  selector: 'app-preloader',
  templateUrl: './preloader.component.html',
  styleUrls: ['./preloader.component.css']
})
export class PreloaderComponent implements OnInit {

  type = '';

  constructor(private router: Router, private utils:Utils, 
    public applicationConstants: ApplicationConstants, private route: ActivatedRoute) {
    console.log('loaded');
  }

  public load() { 
    
    let query = "SELECT * FROM `param` WHERE `status` != '0'";
    let obj = { cmd: 'getList', query: query };
    
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        
        let pl = data.data['list'];
        let params = {};
        for (let i = 0; i < pl.length; i++) {
          params[pl[i]['name']] = pl[i]['value'];
        }
        console.log(params);
        this.applicationConstants.param = params; 

        let query1 = "SELECT * FROM `acct_config` WHERE `status` != '0'";
        let obj1 = { cmd: 'getList', query: query1 };
        this.utils.invokeHttp(this.applicationConstants.generalFile, obj1)
          .subscribe(data2 => {
            this.applicationConstants.appComp.hideBusyCursor();
            
            let confl = data2.data['list'];
            console.log(confl);
            let acct_type_config = {};
            let main_acct_config = {};

            for (let y = 0; y < confl.length; y++) {
              acct_type_config[confl[y]['item_value']] = confl[y]['item_type_number'];
              main_acct_config[confl[y]['item_value']] = confl[y]['item_number'];
            }
            this.applicationConstants.acct_type_config = acct_type_config;
            this.applicationConstants.main_acct_config = main_acct_config;
            this.applicationConstants.isinit = true;

            console.log(this.applicationConstants.acct_type_config);
            console.log(this.applicationConstants.main_acct_config);
            console.log(this.applicationConstants.param);
            // check the version of the app , if it is same, redirect to login. if not show message

            this.router.navigate(['/traveler']);  // this.router.navigate(['/traveler/type']); // 
          });
        
      });
  }

  ngOnInit() {
    this.load();
  }

}
